import React, { ReactNode } from 'react';
import { createUseStyles } from 'react-jss';
import theme from '../../constants/Theme';

interface DialogContentProps {
  children: ReactNode;
}

const DialogContent = ({ children }: DialogContentProps) => {
  const classes = useStyles();

  return (
    <div className={classes.dialogContainer} onClick={e => e.stopPropagation()}>
      {children}
    </div>
  );
};

const useStyles = createUseStyles({
  dialogContainer: {
    width: 484,
    backgroundColor: theme.colors.contrastWhite,
    borderRadius: theme.borderRadius.card,
    boxShadow: theme.shadows.card,
    display: 'flex',
    flexDirection: 'column',
    paddingTop: 32,
    paddingBottom: 32,
    paddingLeft: 16,
    paddingRight: 16,
  },
});

export default DialogContent;
